import { Box, Grid } from "@mui/material"
import { ReactComponent as DeleteIcon } from "../../../assets/DeleteIcon.svg";
import CustomStepper from "../../../component/stepper/CustomStepper";
import { useState } from "react";
import Pianificazionedellavendemmia from "./Pianificazionedellavendemmia";
import RaccoltaUva from "./RaccoltaUva";
import Trasportoeconferimento from "./Trasportoeconferimento";
import Pigiaturaediraspatura from "./Pigiaturaediraspatura";
import FermentazioneeMacerazione from "./FermentazioneeMacerazione";
import PressaturaeSvinatura from "./PressaturaeSvinatura";
import Affinamentoeinvecchiamento from "./Affinamentoeinvecchiamento";
import ImbottigliamentoeStoccaggio from "./ImbottigliamentoeStoccaggio";
import TraccibilitaeCertificazioni from "./TraccibilitaeCertificazioni";


// import StabilimentoForm from "./StabilimentoForm/StabilimentoForm"
// import SubImposteForm from "../Imposte/SubImposteForm"
const steps = [
    'Pianificazione della vendemmia',
    'Raccolta Uva',
    'Trasporto e conferimento',
    'Pigiatura e diraspatura',
    'Fermentazione e macerazione',
    'Pressatura e svinatura',
    'Affinamento e invecchiamento',
    'Imbottigliamento e stoccaggio',
    'Tracciabilita e certificazioni',
];
const option = [
    { label: "Elimina", icon: <DeleteIcon /> },
];

const SubProduzioni = () => {
    const [activeStep, setActiveStep] = useState(1);

    return (
        <>
            <div className="pageTemplate">

                <Grid container spacing={3}>
                    <Grid  size={{lg:3, md:4, xs:12}}>
                        {/* <SubProduzioniForm /> */}
                        <CustomStepper steps={steps} activeStep={activeStep} setActiveStep={setActiveStep} />

                    </Grid>
                    <Grid  size={{lg:9, md:8, xs:12}}>
                        {/* <Box className="TemplateForm__right">
                            <MenuTab SubProduzioni={true} />
                        </Box> */}
                        {/* {Component && <Component />} */}
                        {activeStep === 1 && <Pianificazionedellavendemmia activeStep={activeStep} setActiveStep={setActiveStep} />}
                        {activeStep === 2 && <RaccoltaUva option={option} activeStep={activeStep} setActiveStep={setActiveStep} />}
                        {activeStep === 3 && <Trasportoeconferimento option={option} activeStep={activeStep} setActiveStep={setActiveStep} />}
                        {activeStep === 4 && <Pigiaturaediraspatura option={option} activeStep={activeStep} setActiveStep={setActiveStep} />}
                        {activeStep === 5 && <FermentazioneeMacerazione option={option} activeStep={activeStep} setActiveStep={setActiveStep} />}
                        {activeStep === 6 && <PressaturaeSvinatura option={option} activeStep={activeStep} setActiveStep={setActiveStep} />}
                        {activeStep === 7 && <Affinamentoeinvecchiamento option={option} activeStep={activeStep} setActiveStep={setActiveStep} />}
                        {activeStep === 8 && <ImbottigliamentoeStoccaggio option={option} activeStep={activeStep} setActiveStep={setActiveStep} />}
                        {activeStep === 9 && <TraccibilitaeCertificazioni option={option} activeStep={activeStep} setActiveStep={setActiveStep} />}
                    </Grid>
                </Grid>
            </div>
        </>
    )
}

export default SubProduzioni
